export function formatNumber(
  value: number,
  plusOnPositive: boolean = false,
): string {
  const absValue = Math.abs(value);
  const sign = value < 0 ? "-" : plusOnPositive && value > 0 ? "+" : "";

  if (absValue >= 1_000_000_000) {
    return `${sign}${(absValue / 1_000_000_000).toFixed(1)}B`;
  } else if (absValue >= 1_000_000) {
    return `${sign}${(absValue / 1_000_000).toFixed(1)}M`;
  } else if (absValue >= 1_000) {
    return `${sign}${(absValue / 1_000).toFixed(1)}K`;
  }

  return `${sign}${absValue}`;
}

export function formatMoney(value: number): string {
  return `${formatNumber(value)}`;
}

export function formatPercent(value: number): string {
  return `${Math.round(value)}%`;
}
